import { createContext } from 'react';

import { TTeamSimulationStatisticsDto } from '@app-velocity/av-api-v2';

export type OrgUsageContextType = {
  simStatsByTeam: TTeamSimulationStatisticsDto | null;
};

export const OrgUsageContext = createContext<OrgUsageContextType>({
  simStatsByTeam: null,
});
